'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatabaseContainer = exports.PublicDatabase = exports.Database = undefined;

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var makeUploadAssetRequest = function () {
  var _ref17 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee14(container, asset) {
    var _this4 = this;

    var res, newAsset, postRequest, postUrl;
    return _regenerator2.default.wrap(function _callee14$(_context14) {
      while (1) {
        switch (_context14.prev = _context14.next) {
          case 0:
            _context14.next = 2;
            return container.makeRequest('asset:put', {
              filename: asset.name,
              'content-type': asset.contentType,
              // asset.file.size for File and Blob
              // asset.file.byteLength for Buffer
              'content-size': asset.file.size || asset.file.byteLength
            });

          case 2:
            res = _context14.sent;
            newAsset = _asset2.default.fromJSON(res.result.asset);
            postRequest = res.result['post-request'];
            postUrl = postRequest.action;

            if (postUrl.indexOf('/') === 0) {
              postUrl = postUrl.substring(1);
            }
            if (postUrl.indexOf('http') !== 0) {
              postUrl = container.url + postUrl;
            }

            _context14.next = 10;
            return new Promise(function (resolve, reject) {
              var _request = container.request.post(postUrl).set('X-Skygear-API-Key', container.apiKey);
              if (postRequest['extra-fields']) {
                _lodash2.default.forEach(postRequest['extra-fields'], function (value, key) {
                  _request = _request.field(key, value);
                });
              }

              if (asset.file instanceof Buffer) {
                // need providing file name to buffer
                _request = _request.attach('file', asset.file, asset.name);
              } else {
                _request = _request.attach('file', asset.file);
              }

              _request.end(function () {
                var _ref18 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee13(err) {
                  var _ref19, _ref20, code, message;

                  return _regenerator2.default.wrap(function _callee13$(_context13) {
                    while (1) {
                      switch (_context13.prev = _context13.next) {
                        case 0:
                          if (!err) {
                            _context13.next = 15;
                            break;
                          }

                          _context13.prev = 1;
                          _context13.next = 4;
                          return parseS3XmlErrorMessage(err);

                        case 4:
                          _ref19 = _context13.sent;
                          _ref20 = (0, _slicedToArray3.default)(_ref19, 2);
                          code = _ref20[0];
                          message = _ref20[1];

                          reject(_s3ErrorToSkyError(code, message));
                          _context13.next = 14;
                          break;

                        case 11:
                          _context13.prev = 11;
                          _context13.t0 = _context13['catch'](1);

                          reject(err);

                        case 14:
                          return _context13.abrupt('return');

                        case 15:

                          resolve();

                        case 16:
                        case 'end':
                          return _context13.stop();
                      }
                    }
                  }, _callee13, _this4, [[1, 11]]);
                }));

                return function (_x21) {
                  return _ref18.apply(this, arguments);
                };
              }());
            });

          case 10:
            return _context14.abrupt('return', newAsset);

          case 11:
          case 'end':
            return _context14.stop();
        }
      }
    }, _callee14, this);
  }));

  return function makeUploadAssetRequest(_x19, _x20) {
    return _ref17.apply(this, arguments);
  };
}();

/**
 * Best effort to parse s3 error code and message.
 * If success, resolve with [code, message].
 */


var parseS3XmlErrorMessage = function () {
  var _ref21 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee15(error) {
    var result;
    return _regenerator2.default.wrap(function _callee15$(_context15) {
      while (1) {
        switch (_context15.prev = _context15.next) {
          case 0:
            if (!(!error.response || !error.response.text)) {
              _context15.next = 2;
              break;
            }

            throw new Error('Unable to get response text');

          case 2:
            result = _fastXmlParser2.default.parse(error.response.text);

            if (!(result.Error && result.Error.Code && typeof result.Error.Code === 'string' && result.Error.Message && typeof result.Error.Message === 'string')) {
              _context15.next = 5;
              break;
            }

            return _context15.abrupt('return', [result.Error.Code, result.Error.Message]);

          case 5:
            throw new Error('Malformed S3 response error');

          case 6:
          case 'end':
            return _context15.stop();
        }
      }
    }, _callee15, this);
  }));

  return function parseS3XmlErrorMessage(_x22) {
    return _ref21.apply(this, arguments);
  };
}();

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _fastXmlParser = require('fast-xml-parser');

var _fastXmlParser2 = _interopRequireDefault(_fastXmlParser);

var _cache = require('./cache');

var _cache2 = _interopRequireDefault(_cache);

var _asset = require('./asset');

var _asset2 = _interopRequireDefault(_asset);

var _record = require('./record');

var _query2 = require('./query');

var _query3 = _interopRequireDefault(_query2);

var _query_result = require('./query_result');

var _query_result2 = _interopRequireDefault(_query_result);

var _util = require('./util');

var _error = require('./error');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Database = function () {

  /**
   * Creates a Skygear database.
   *
   * @param  {String} dbID - database ID
   * @param  {Container} container - Skygear Container
   * @return {Database}
   */
  function Database(dbID, container) {
    (0, _classCallCheck3.default)(this, Database);

    if (dbID !== '_public' && dbID !== '_private' && dbID !== '_union') {
      throw new Error('Invalid database_id');
    }

    /**
     * The database ID
     * @type {String}
     */
    this.dbID = dbID;

    /**
     * @private
     */
    this.container = container;
    this._cacheStore = new _cache2.default(this.dbID, this.container.store);
    this._cacheResponse = true;
  }

  /**
   * Fetches a single record with the specified id from Skygear.
   *
   * Use this method to fetch a single record from Skygear by specifying a
   * record ID in the format of `type/id`. The fetch will be performed
   * asynchronously and the returned promise will be resolved when the
   * operation completes.
   *
   * @param  {String} id - record ID with format `type/id`
   * @return {Promise<Record>} promise with the fetched Record
   */


  (0, _createClass3.default)(Database, [{
    key: 'getRecordByID',
    value: function () {
      var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(id) {
        var Record, _Record$parseID, _Record$parseID2, recordType, recordId, query, users;

        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                Record = this._Record;
                _Record$parseID = Record.parseID(id), _Record$parseID2 = (0, _slicedToArray3.default)(_Record$parseID, 2), recordType = _Record$parseID2[0], recordId = _Record$parseID2[1];
                query = new _query3.default(Record.extend(recordType)).equalTo('_id', recordId);
                _context.next = 5;
                return this.query(query);

              case 5:
                users = _context.sent;

                if (!(users.length === 1)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt('return', users[0]);

              case 10:
                throw new Error(id + ' does not exist');

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getRecordByID(_x) {
        return _ref.apply(this, arguments);
      }

      return getRecordByID;
    }()

    /**
     * Fetches records that match the Query from Skygear.
     *
     * Use this method to fetch records from Skygear by specifying a Query.
     * The fetch will be performed asynchronously and the returned promise will
     * be resolved when the operation completes.
     *
     * If cacheCallback is provided, the SDK would try to fetch result of the
     * query from local cache, before issuing query request to the server, and
     * trigger the cacheCallback function if cached result is found.
     *
     * @param  {Query} query
     * @param  {function(queryResult:QueryResult,isCached:boolean)} cacheCallback
     * @return {Promise<QueryResult>} promise with the QueryResult
     */

  }, {
    key: 'query',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(_query) {
        var _this = this;

        var cacheCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        var remoteReturned, cacheStore, Cls, queryJSON, payload, body, records, result;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                remoteReturned = false;
                cacheStore = this.cacheStore;
                Cls = _query.recordCls;
                queryJSON = _query.toJSON();


                if (!queryJSON.offset && queryJSON.page > 0) {
                  queryJSON.offset = queryJSON.limit * (queryJSON.page - 1);
                }

                payload = _lodash2.default.assign({
                  database_id: this.dbID //eslint-disable-line
                }, queryJSON);


                if (cacheCallback) {
                  (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2() {
                    var _body, _records2, _result;

                    return _regenerator2.default.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.prev = 0;
                            _context2.next = 3;
                            return cacheStore.get(_query.hash);

                          case 3:
                            _body = _context2.sent;

                            if (!remoteReturned) {
                              _context2.next = 6;
                              break;
                            }

                            return _context2.abrupt('return');

                          case 6:
                            _records2 = _lodash2.default.map(_body.result, function (attrs) {
                              return new Cls(attrs);
                            });
                            _result = _query_result2.default.createFromResult(_records2, _body.info);

                            cacheCallback(_result, true);
                            _context2.next = 14;
                            break;

                          case 11:
                            _context2.prev = 11;
                            _context2.t0 = _context2['catch'](0);

                            console.log('No cache found', _context2.t0);

                          case 14:
                          case 'end':
                            return _context2.stop();
                        }
                      }
                    }, _callee2, _this, [[0, 11]]);
                  }))();
                }

                _context3.next = 9;
                return this.container.makeRequest('record:query', payload);

              case 9:
                body = _context3.sent;
                records = _lodash2.default.map(body.result, function (attrs) {
                  return new Cls(attrs);
                });
                result = _query_result2.default.createFromResult(records, body.info);

                remoteReturned = true;

                if (!this.cacheResponse) {
                  _context3.next = 16;
                  break;
                }

                _context3.next = 16;
                return cacheStore.set(_query.hash, body);

              case 16:
                return _context3.abrupt('return', result);

              case 17:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function query(_x2) {
        return _ref2.apply(this, arguments);
      }

      return query;
    }()

    /**
     * Presave a single value.
     *
     * A single value is the smallest unit of object to presave. In other words,
     * a single value does not contain smaller values to presave.
     *
     * This function returns a promise that may perform other operations, such
     * as calling the server to upload asset.
     */

  }, {
    key: '_presaveSingleValue',
    value: function () {
      var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee4(value) {
        return _regenerator2.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!((0, _asset.isAsset)(value) && value.file)) {
                  _context4.next = 4;
                  break;
                }

                return _context4.abrupt('return', this.uploadAsset(value));

              case 4:
                return _context4.abrupt('return', value);

              case 5:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _presaveSingleValue(_x4) {
        return _ref4.apply(this, arguments);
      }

      return _presaveSingleValue;
    }()

    /**
     * Presave a value as part of a key-value object.
     *
     * This function differs from _presave in that it returns the key of the
     * parent object that is being presaved. This helps constructs the object
     * after resolving all promises.
     */

  }, {
    key: '_presaveKeyValue',
    value: function () {
      var _ref5 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee5(fn, key, value) {
        var v;
        return _regenerator2.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return this._presave(fn, value);

              case 2:
                v = _context5.sent;
                return _context5.abrupt('return', [key, v]);

              case 4:
              case 'end':
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _presaveKeyValue(_x5, _x6, _x7) {
        return _ref5.apply(this, arguments);
      }

      return _presaveKeyValue;
    }()

    /**
     * Presave a value.
     *
     * If the value contains other objects that can be presaved, it will
     * iterates each member and create a promise for such object. Essentially this
     * function creates a tree of promises that resembles the object tree.
     */

  }, {
    key: '_presave',
    value: function () {
      var _ref6 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee6(fn, value) {
        var _this2 = this;

        var record, tasks, keyvalues, obj, _tasks, _keyvalues;

        return _regenerator2.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                if (!(value === undefined || value === null)) {
                  _context6.next = 4;
                  break;
                }

                return _context6.abrupt('return', value);

              case 4:
                if (!_lodash2.default.isArray(value)) {
                  _context6.next = 8;
                  break;
                }

                return _context6.abrupt('return', Promise.all(_lodash2.default.map(value, this._presave.bind(this, fn))));

              case 8:
                if (!(0, _record.isRecord)(value)) {
                  _context6.next = 18;
                  break;
                }

                record = value;
                tasks = _lodash2.default.map(record, function (v, k) {
                  return _this2._presaveKeyValue(fn, k, v);
                });
                _context6.next = 13;
                return Promise.all(tasks);

              case 13:
                keyvalues = _context6.sent;

                _lodash2.default.each(keyvalues, function (_ref7) {
                  var _ref8 = (0, _slicedToArray3.default)(_ref7, 2),
                      k = _ref8[0],
                      v = _ref8[1];

                  record[k] = v;
                });
                return _context6.abrupt('return', record);

              case 18:
                if (!((0, _util.isValueType)(value) || !_lodash2.default.isObject(value))) {
                  _context6.next = 22;
                  break;
                }

                return _context6.abrupt('return', fn(value));

              case 22:
                obj = value;
                _tasks = _lodash2.default.chain(obj).keys().map(function (key) {
                  return _this2._presaveKeyValue(fn, key, obj[key]);
                }).value();
                _context6.next = 26;
                return Promise.all(_tasks);

              case 26:
                _keyvalues = _context6.sent;

                _lodash2.default.each(_keyvalues, function (_ref9) {
                  var _ref10 = (0, _slicedToArray3.default)(_ref9, 2),
                      k = _ref10[0],
                      v = _ref10[1];

                  obj[k] = v;
                });
                return _context6.abrupt('return', obj);

              case 29:
              case 'end':
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function _presave(_x8, _x9) {
        return _ref6.apply(this, arguments);
      }

      return _presave;
    }()

    /**
     * Same as {@link Database#delete}.
     *
     * @param  {Record|Record[]|QueryResult} record - the record(s) to delete
     * @return {Promise<Record>} promise with the delete result
     * @see {@link Database#delete}
     */

  }, {
    key: 'del',
    value: function () {
      var _ref11 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee7(record) {
        return _regenerator2.default.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                return _context7.abrupt('return', this.delete(record));

              case 1:
              case 'end':
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function del(_x10) {
        return _ref11.apply(this, arguments);
      }

      return del;
    }()

    /**
     * Saves a record or records to Skygear.
     *
     * Use this method to save a record or records to Skygear.
     * The save will be performed asynchronously and the returned promise will
     * be resolved when the operation completes.
     *
     * New record will be created in the database while existing
     * record will be modified.
     *
     * options.atomic can be set to true, which makes the operation either
     * success or failure, but not partially success.
     *
     * @param {Record|Record[]} _records - the record(s) to save
     * @param {Object} [options={}] options - options for saving the records
     * @param {Boolean} [options.atomic] - true if the save request should be
     * atomic
     * @return {Promise<Record>} promise with saved records
     */

  }, {
    key: 'save',
    value: function () {
      var _ref12 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee8(_records) {
        var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var records, processedRecords, payload, body, results, savedRecords, errors;
        return _regenerator2.default.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                records = _records;

                if (!_lodash2.default.isArray(records)) {
                  records = [records];
                }

                if (!_lodash2.default.some(records, function (r) {
                  return r === undefined || r === null;
                })) {
                  _context8.next = 4;
                  break;
                }

                throw new Error('Invalid input, unable to save undefined and null');

              case 4:
                _context8.next = 6;
                return this._presave(this._presaveSingleValue.bind(this), records);

              case 6:
                processedRecords = _context8.sent;
                payload = {
                  database_id: this.dbID //eslint-disable-line
                };


                if (options.atomic) {
                  payload.atomic = true;
                }

                payload.records = _lodash2.default.map(processedRecords, function (perRecord) {
                  return perRecord.toTruncatedJSON();
                });

                _context8.next = 12;
                return this.container.makeRequest('record:save', payload);

              case 12:
                body = _context8.sent;
                results = body.result;
                savedRecords = [];
                errors = [];


                _lodash2.default.forEach(results, function (perResult, idx) {
                  if (perResult._type === 'error') {
                    savedRecords[idx] = undefined;
                    errors[idx] = perResult;
                  } else {
                    records[idx].update(perResult);
                    records[idx].updateTransient(perResult._transient, true);

                    savedRecords[idx] = records[idx];
                    errors[idx] = undefined;
                  }
                });

                if (!(records.length === 1)) {
                  _context8.next = 21;
                  break;
                }

                if (!errors[0]) {
                  _context8.next = 20;
                  break;
                }

                throw errors[0];

              case 20:
                return _context8.abrupt('return', savedRecords[0]);

              case 21:
                return _context8.abrupt('return', { savedRecords: savedRecords, errors: errors });

              case 22:
              case 'end':
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function save(_x11) {
        return _ref12.apply(this, arguments);
      }

      return save;
    }()

    /**
     * Deletes a record or records to Skygear.
     *
     * Use this method to delete a record or records to Skygear.
     * The delete will be performed asynchronously and the returned promise will
     * be resolved when the operation completes.
     *
     * @param  {Record|Record[]|QueryResult} _records - the records to delete
     * @return {Promise} promise
     */

  }, {
    key: 'delete',
    value: function () {
      var _ref13 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee9(_records) {
        var records, isQueryResult, ids, payload, body, results, errors;
        return _regenerator2.default.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                records = _records;
                isQueryResult = records instanceof _query_result2.default;

                if (!_lodash2.default.isArray(records) && !isQueryResult) {
                  records = [records];
                }

                ids = _lodash2.default.map(records, function (perRecord) {
                  return perRecord.id;
                });
                payload = {
                  database_id: this.dbID, //eslint-disable-line
                  ids: ids
                };
                _context9.next = 7;
                return this.container.makeRequest('record:delete', payload);

              case 7:
                body = _context9.sent;
                results = body.result;
                errors = [];


                _lodash2.default.forEach(results, function (perResult, idx) {
                  if (perResult._type === 'error') {
                    errors[idx] = perResult;
                  } else {
                    errors[idx] = undefined;
                  }
                });

                if (!(records.length === 1)) {
                  _context9.next = 15;
                  break;
                }

                if (!errors[0]) {
                  _context9.next = 14;
                  break;
                }

                throw errors[0];

              case 14:
                return _context9.abrupt('return');

              case 15:
                return _context9.abrupt('return', errors);

              case 16:
              case 'end':
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function _delete(_x13) {
        return _ref13.apply(this, arguments);
      }

      return _delete;
    }()

    /**
     * @type {Store}
     */

  }, {
    key: 'uploadAsset',


    /**
     * Uploads asset to Skygear server.
     *
     * @param  {Asset} asset - the asset
     * @return {Promise<Asset>} promise
     */
    value: function uploadAsset(asset) {
      return makeUploadAssetRequest(this.container, asset);
    }
  }, {
    key: 'cacheStore',
    get: function get() {
      return this._cacheStore;
    }

    /**
     * Indicating if query result should be cached locally
     *
     * @type {boolean}
     */

  }, {
    key: 'cacheResponse',
    get: function get() {
      return this._cacheResponse;
    }

    /**
     * Indicating if query result should be cached locally
     *
     * @type {boolean}
     */
    ,
    set: function set(value) {
      var b = !!value;
      this._cacheResponse = b;
    }
  }, {
    key: '_Record',
    get: function get() {
      return this.container.Record;
    }
  }]);
  return Database;
}(); /**
      * Copyright 2015 Oursky Ltd.
      *
      * Licensed under the Apache License, Version 2.0 (the "License");
      * you may not use this file except in compliance with the License.
      * You may obtain a copy of the License at
      *
      *     http://www.apache.org/licenses/LICENSE-2.0
      *
      * Unless required by applicable law or agreed to in writing, software
      * distributed under the License is distributed on an "AS IS" BASIS,
      * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
      * See the License for the specific language governing permissions and
      * limitations under the License.
      */


exports.Database = Database;

var PublicDatabase = exports.PublicDatabase = function (_Database) {
  (0, _inherits3.default)(PublicDatabase, _Database);

  function PublicDatabase() {
    (0, _classCallCheck3.default)(this, PublicDatabase);
    return (0, _possibleConstructorReturn3.default)(this, (PublicDatabase.__proto__ || Object.getPrototypeOf(PublicDatabase)).apply(this, arguments));
  }

  (0, _createClass3.default)(PublicDatabase, [{
    key: 'setDefaultACL',


    /**
     * Sets default ACL of a newly created record.
     *
     * @param {ACL} acl - the default acl
     */
    value: function setDefaultACL(acl) {
      this._Record.defaultACL = acl;
    }

    /**
     * Sets the roles that are allowed to create records of a record type.
     *
     * @param {Class} recordClass - the record class created with
     * {@link Record.extend}
     * @param {Role[]} roles - the roles
     * @return {Promise} promise
     */

  }, {
    key: 'setRecordCreateAccess',
    value: function () {
      var _ref14 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee10(recordClass, roles) {
        var roleNames, body;
        return _regenerator2.default.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                roleNames = _lodash2.default.map(roles, function (perRole) {
                  return perRole.name;
                });
                _context10.next = 3;
                return this.container.makeRequest('schema:access', {
                  type: recordClass.recordType,
                  create_roles: roleNames //eslint-disable-line camelcase
                });

              case 3:
                body = _context10.sent;
                return _context10.abrupt('return', body.result);

              case 5:
              case 'end':
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setRecordCreateAccess(_x14, _x15) {
        return _ref14.apply(this, arguments);
      }

      return setRecordCreateAccess;
    }()

    /**
     * Sets the default ACL of a newly created record of a record type.
     *
     * @param {Class} recordClass - the record class created with
     * {@link Record.extend}
     * @param {ACL} acl - the default acl
     * @return {Promise} promise
     */

  }, {
    key: 'setRecordDefaultAccess',
    value: function () {
      var _ref15 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee11(recordClass, acl) {
        var body;
        return _regenerator2.default.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return this.container.makeRequest('schema:default_access', {
                  type: recordClass.recordType,
                  default_access: acl.toJSON() //eslint-disable-line camelcase
                });

              case 2:
                body = _context11.sent;
                return _context11.abrupt('return', body.result);

              case 4:
              case 'end':
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setRecordDefaultAccess(_x16, _x17) {
        return _ref15.apply(this, arguments);
      }

      return setRecordDefaultAccess;
    }()
  }, {
    key: 'defaultACL',


    /**
     * The default ACL of a newly created record
     *
     * @type {ACL}
     */
    get: function get() {
      return this._Record.defaultACL;
    }
  }]);
  return PublicDatabase;
}(Database);

/**
 * @private
 */


var DatabaseContainer = exports.DatabaseContainer = function () {

  /**
   * Creates a DatabaseContainer.
   *
   * @param  {Container} container - the Skygear container
   */
  function DatabaseContainer(container) {
    (0, _classCallCheck3.default)(this, DatabaseContainer);

    /**
     * @private
     */
    this.container = container;

    this._public = null;
    this._private = null;
    this._cacheResponse = true;
  }

  /**
   * @type {PublicDatabase}
   */


  (0, _createClass3.default)(DatabaseContainer, [{
    key: 'uploadAsset',


    /**
     * Uploads asset to Skygear server.
     *
     * @deprecated use Database.uploadAsset instead.
     *
     * @param  {Asset} asset - the asset
     * @return {Promise<Asset>} promise
     */
    value: function () {
      var _ref16 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee12(asset) {
        return _regenerator2.default.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                return _context12.abrupt('return', this.public.uploadAsset(asset));

              case 1:
              case 'end':
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function uploadAsset(_x18) {
        return _ref16.apply(this, arguments);
      }

      return uploadAsset;
    }()

    /**
     * True if the database cache result from response
     *
     * @type {Boolean}
     */

  }, {
    key: 'public',
    get: function get() {
      if (this._public === null) {
        this._public = new PublicDatabase('_public', this.container);
        this._public.cacheResponse = this._cacheResponse;
      }
      return this._public;
    }

    /**
     * Private database of the current user
     *
     * @type {Database}
     */

  }, {
    key: 'private',
    get: function get() {
      if (this.container.accessToken === null) {
        throw new Error('You must login before access to privateDB');
      }
      if (this._private === null) {
        this._private = new Database('_private', this.container);
        this._private.cacheResponse = this._cacheResponse;
      }
      return this._private;
    }
  }, {
    key: 'cacheResponse',
    get: function get() {
      return this._cacheResponse;
    }

    /**
     * True if the database cache result from response
     *
     * @type {Boolean}
     */
    ,
    set: function set(value) {
      var b = !!value;
      this._cacheResponse = b;
      if (this._public) {
        this._public.cacheResponse = b;
      }
      if (this._private) {
        this._private.cacheResponse = b;
      }
    }
  }]);
  return DatabaseContainer;
}();

function _s3ErrorToSkyError(code, message) {
  var codeMap = {
    EntityTooLarge: _error.ErrorCodes.AssetSizeTooLarge
  };

  return new _error.SkygearError(message, codeMap[code] || _error.ErrorCodes.UnexpectedError);
}